import React, { useState, useEffect } from 'react';
import breakPoint from '../../utils/constants';
import { getUserDevice } from '../../utils/getUserDevice';
import { useWindowDimensions } from '../../hooks/windowDimension';

const App = ({ children }) => {
    const [device, setDevice] = useState('desktop');
    const { width } = useWindowDimensions();

    useEffect(() => {
        const userDevice = getUserDevice();
        if (userDevice === 'mobile' && width < breakPoint.mediumWidth) {
            setDevice('mobile');
            return;
        }

        if (width > breakPoint.mediumWidth) {
            setDevice('desktop');
        } else {
            setDevice('mobile');
        }
    }, [width]);

    return (
        <div className="app" data-layout={device}>
            {children}
        </div>
    );
};

export default App;
